import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Artists from './components/Artists/Artists';
import Pricing from './components/Pricing/Pricing';
import Care from './components/Care/Care';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <Router>
      <GlobalStyles />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Home />
              <Artists />
              <Pricing />
              <Care />
              <Contact />
            </>
          } />
          <Route path="/artistes" element={<Artists />} />
          <Route path="/tarifs" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
